<!-- SIDE PANEL -->

<ng-container *ngIf="!giantConfig.layout.sidepanel.hidden && giantConfig.layout.sidepanel.position === 'left'">

    <!-- PANEL CONTENT -->

</ng-container>
<!-- / SIDE PANEL -->
<div class="navbar-top" [ngClass]="giantConfig.layout.navbar.secondaryBackground">
    <div class="buttons">
        <button mat-icon-button class="toggle-sidebar-folded" (click)="toggleSidebar()">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="feather feather-menu page-header-title burger-menu-custom">
                <line x1="3" y1="12" x2="21" y2="12"></line>
                <line x1="3" y1="6" x2="21" y2="6"></line>
                <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
        </button>
 
    </div>
    <div class="logo">
        <img class="logo-icon" src="assets/images/logo/giant2_new.png">
        <!-- <span class="logo-text secondary-text">giant data safe</span> -->
    </div>
</div>
<div id="main">
    <!-- TOOLBAR: Below static -->
    <ng-container *ngIf="giantConfig.layout.toolbar.position === 'below-static'  && isNotLoginPage===true">
        <ng-container *ngTemplateOutlet="toolbar"></ng-container>
    </ng-container>
    <!-- / TOOLBAR: Below static -->
    <!-- TOOLBAR: Above -->
    <ng-container *ngIf="giantConfig.layout.toolbar.position === 'above'  && isNotLoginPage===true">
        <ng-container *ngTemplateOutlet="toolbar"></ng-container>
    </ng-container>
    <!-- / TOOLBAR: Above -->

    <div id="container-1" class="container">

        <!-- NAVBAR: Left -->
        <ng-container *ngIf="giantConfig.layout.navbar.position === 'left' && isNotLoginPage===true">
            <ng-container *ngTemplateOutlet="leftNavbar"></ng-container>
        </ng-container>
        <!-- / NAVBAR: Left -->

        <div id="container-2" class="container" (click)="OuttoggleClick()">

            <!-- TOOLBAR: Below fixed -->
            <ng-container *ngIf="giantConfig.layout.toolbar.position === 'below-fixed'  && isNotLoginPage===true">
                <ng-container *ngTemplateOutlet="toolbar"></ng-container>
            </ng-container>
            <!-- / TOOLBAR: Below fixed -->

            <div id="container-3" class="container" giantPerfectScrollbar
                [giantPerfectScrollbarOptions]="{suppressScrollX: true, updateOnRouteChange : true}">

                <!-- CONTENT -->
                <content></content>
                <!-- / CONTENT -->

                <!-- FOOTER: Below static -->
                <ng-container *ngIf="giantConfig.layout.footer.position === 'below-static'  && isNotLoginPage===true">
                    <ng-container *ngTemplateOutlet="footer"></ng-container>
                </ng-container>
                <!-- / FOOTER: Below static -->
            </div>

            <!-- FOOTER: Below fixed -->
            <ng-container *ngIf="giantConfig.layout.footer.position === 'below-fixed'  && isNotLoginPage===true">
                <ng-container *ngTemplateOutlet="footer"></ng-container>
            </ng-container>
            <!-- / FOOTER: Below fixed -->

        </div>

        <!-- NAVBAR: Right -->
        <ng-container *ngIf="giantConfig.layout.navbar.position === 'right'  && isNotLoginPage===true">
            <ng-container *ngTemplateOutlet="rightNavbar"></ng-container>
        </ng-container>
        <!-- / NAVBAR: Right -->

    </div>

    <!-- FOOTER: Above -->
    <ng-container *ngIf="giantConfig.layout.footer.position === 'above'  && isNotLoginPage===true">
        <ng-container *ngTemplateOutlet="footer"></ng-container>
    </ng-container>
    <!-- FOOTER: Above -->
</div>


<!-- TOOLBAR -->
<ng-template #toolbar>
    <toolbar *ngIf="!giantConfig.layout.toolbar.hidden"
        [ngClass]="giantConfig.layout.toolbar.customBackgroundColor === true ? giantConfig.layout.toolbar.position + ' ' + giantConfig.layout.toolbar.background : giantConfig.layout.toolbar.position">
    </toolbar>
</ng-template>
<!-- / TOOLBAR -->

<!-- FOOTER -->
<ng-template #footer>
    <footer *ngIf="!giantConfig.layout.footer.hidden"
        [ngClass]="giantConfig.layout.footer.customBackgroundColor === true ? giantConfig.layout.footer.position + ' ' + giantConfig.layout.footer.background : giantConfig.layout.footer.position">
    </footer>
</ng-template>
<!-- / FOOTER -->

<!-- LEFT NAVBAR -->
<ng-template #leftNavbar>
    <giant-sidebar name="navbar" class="navbar-giant-sidebar" [folded]="giantConfig.layout.navbar.folded"
        lockedOpen="gt-md" *ngIf="!giantConfig.layout.navbar.hidden" [ngClass]="status ? 'folded' : 'unfolded'">
        <navbar [variant]="giantConfig.layout.navbar.variant" class="left-navbar" (click)="reloadCurrentPage()"></navbar>
    </giant-sidebar>
</ng-template>
<!-- / LEFT NAVBAR -->
